import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid2";
import { Alert, AlertTitle } from "@mui/material";
import { useStyles } from "./Modal.styles";
import { LargeActionButton } from "../Common/LargeActionButton";
import { LargeActionLink } from "../Common/LargeActionLink";
import { compactSecondaryModalActionStyles, primaryModalActionStyles } from "../Common/modalActionStyles";

interface ModalProps {
	isOpen: boolean;
	title: string;
	paragraphs: Array<string>;
	isSuccess?: boolean;
	isInfo?: boolean;
	isWarning?: boolean;
	primaryButtonName: string;
	secondaryButtonName?: string;
	onPrimaryButtonClick: () => void;
	onSecondaryButtonClick?: () => void;
	isPrimaryButtonDisabled?: boolean;
	isExitable?: boolean;
}

export const Modal = ({
	isOpen,
	title,
	paragraphs,
	isSuccess,
	isInfo,
	isWarning,
	primaryButtonName,
	secondaryButtonName,
	onPrimaryButtonClick,
	onSecondaryButtonClick,
	isPrimaryButtonDisabled,
	isExitable,
}: ModalProps) => {
	const classes = useStyles();
	const getAlertType = () => {
		switch (true) {
			case isSuccess:
				return "success";
			case isInfo:
				return "info";
			case isWarning:
				return "warning";
			default:
				return "error";
		}
	};
	return (
		<Dialog open={isOpen}>
			<DialogTitle className={classes.dialogTitle}>
				<Alert
					severity={getAlertType()}
					variant="outlined"
					className={classes.alert}
					onClose={isExitable ? () => {} : undefined}
				>
					{title && <AlertTitle className={classes.alertTitle}>{title}</AlertTitle>}
				</Alert>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				{paragraphs.map((p, idx) => (
					<DialogContentText key={idx} className={classes.dialogContentMessage} paragraph>
						{p}
					</DialogContentText>
				))}
			</DialogContent>
			<DialogActions className={classes.largeDialogActions}>
				<Grid container direction="column" justifyContent="center" alignItems="center" spacing={1} sx={{ width: '100%' }}>
					<Grid size={12} sx={{ width: '100%' }}>
						<LargeActionButton
							onClick={onPrimaryButtonClick}
							disabled={isPrimaryButtonDisabled}
							sx={primaryModalActionStyles}
							children={primaryButtonName}
						/>
					</Grid>
					{secondaryButtonName && onSecondaryButtonClick && (
                        <Grid size={12} sx={{ width: '100%' }}>
                            <LargeActionLink 
                                onClick={onSecondaryButtonClick} 
                                sx={compactSecondaryModalActionStyles}
                                children={secondaryButtonName} 
                            />
                        </Grid>
                    )}
				</Grid>
			</DialogActions>
		</Dialog>
	);
};